/**
 * Formate une durée en secondes au format `m:ss` (ou `h:mm:ss` au-delà d'une heure).
 *
 * @param seconds - Durée en secondes, ou `null` si inconnue.
 * @returns La durée formatée, ou une chaîne vide si inconnue.
 */
export function formatDuration(seconds: number | null): string {
	if (seconds === null || !Number.isFinite(seconds)) {
		return '';
	}
	const totalSeconds = Math.max(0, Math.round(seconds));
	const hours = Math.floor(totalSeconds / 3600);
	const minutes = Math.floor((totalSeconds % 3600) / 60);
	const secs = totalSeconds % 60;

	if (hours > 0) {
		return `${hours}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
	}
	return `${minutes}:${String(secs).padStart(2, '0')}`;
}

/**
 * Formate une date de mise en ligne au format `YYYYMMDD` (tel que renvoyé
 * par yt-dlp) en `JJ/MM/AAAA`.
 *
 * @param uploadDate - Date au format `YYYYMMDD`, ou `null` si inconnue.
 * @returns La date formatée, ou une chaîne vide si inconnue ou mal formée.
 */
export function formatUploadDate(uploadDate: string | null): string {
	if (!uploadDate || !/^\d{8}$/.test(uploadDate)) {
		return '';
	}
	const year = uploadDate.slice(0, 4);
	const month = uploadDate.slice(4, 6);
	const day = uploadDate.slice(6, 8);
	return `${day}/${month}/${year}`;
}
